import { createContext, useContext } from "react";

import type { DialogPlacement } from "./styles";

interface DialogContextValue {
  placement: DialogPlacement;
  open: boolean;
}

export const DialogContext = createContext<DialogContextValue>({ placement: "viewport", open: false });

export const useDialogContext = () => useContext(DialogContext);

interface DialogContentContextValue {
  divided: boolean;
}

export const DialogContentContext = createContext<DialogContentContextValue>({ divided: false });

export const useDialogContentContext = () => useContext(DialogContentContext);
